import { Check } from "lucide-react";
import { Reveal, Eyebrow, CTAButton } from "./Shared";

const RECAP = [
  "The complete BLUEPRINT course + all masterclasses",
  "BONUS: BECOMING HER Blueprint™ book",
  "Skool community access",
  "Instant digital delivery",
];

export default function FinalCta() {
  return (
    <section id="checkout" data-testid="final-cta-section" className="relative pt-20 sm:pt-32 overflow-hidden">
      <span
        aria-hidden="true"
        className="pointer-events-none select-none absolute -bottom-10 left-1/2 -translate-x-1/2 font-display font-extrabold uppercase leading-none text-[22vw] text-outline whitespace-nowrap"
      >
        Becoming
      </span>
      <div className="relative max-w-6xl mx-auto px-4 sm:px-8 text-center">
        <Reveal>
          <Eyebrow className="justify-center">The decision</Eyebrow>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 font-display font-extrabold uppercase tracking-tight leading-[0.92] text-4xl sm:text-6xl lg:text-7xl">
            Stop collecting ideas.
            <span className="block mt-2 font-serif italic normal-case font-medium text-lime">
              Start building the person.
            </span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-8 max-w-xl mx-auto text-sm sm:text-base leading-relaxed text-fog">
            You already have the ambition, the knowledge, the strategy. What you&rsquo;re missing
            isn&rsquo;t another plan —{" "}
            <span className="text-cream">it&rsquo;s the blueprint for who you&rsquo;re becoming.</span>
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-12 max-w-lg mx-auto border border-lime/40 bg-coal/80 backdrop-blur p-7 sm:p-10 text-left relative">
            <span className="absolute -top-px left-1/2 -translate-x-1/2 -translate-y-1/2 bg-lime text-ink font-mono text-[9px] font-semibold tracking-[0.2em] uppercase px-4 py-1.5">
              Blueprint™ — Complete Bundle
            </span>
            <ul className="space-y-3.5 mt-2">
              {RECAP.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <Check size={16} strokeWidth={3} className="text-lime mt-1 shrink-0" />
                  <span className="text-sm sm:text-base text-cream/90">{item}</span>
                </li>
              ))}
            </ul>
            <div className="mt-8 flex items-end justify-between gap-4">
              <div>
                <span className="font-display font-extrabold text-6xl leading-none">$111</span>
                <span className="block font-mono text-[9px] tracking-[0.25em] uppercase text-fog mt-2">
                  One-time payment
                </span>
              </div>
              <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-gold">
                Instant access
              </span>
            </div>
            <CTAButton testId="final-cta-button" className="w-full mt-8">
              Build my blueprint — $111
            </CTAButton>
            <p className="mt-4 font-mono text-[10px] tracking-[0.2em] uppercase text-fog text-center">
              One payment · Instant digital access
            </p>
          </div>
        </Reveal>
      </div>

      <footer className="relative mt-20 sm:mt-28 border-t border-cream/10">
        <div className="max-w-6xl mx-auto px-4 sm:px-8 py-10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-display font-extrabold tracking-tight">
            BLUEPRINT<span className="text-lime">™</span>
          </p>
          <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-fog text-center">
            © 2026 Dasha Love · All rights reserved
          </p>
        </div>
        <div className="max-w-6xl mx-auto px-4 sm:px-8 pb-10">
          <p className="text-[11px] leading-relaxed text-fog/70 max-w-3xl">
            BLUEPRINT™ is a personal-development and business-education product. Identity, belief,
            meditation, mantra, and quantum-themed practices inside are offered as reflection and
            experimentation tools. Nothing on this page is financial, medical, or psychological
            advice, and no specific income or business result is promised or guaranteed.
          </p>
        </div>
      </footer>
    </section>
  );
}
